export class Health {

  public status: string;
  public diskSpaceStatus: string;
  public diskSpaceFree: number;
  public diskSpaceUsed: number;
  public diskSpaceTotal: number;
  public diskSpacePercent: number;
  public dbStatus: string;
  public dbName: string;


  public static fromDto(h): Health {
    const health = new Health();

    health.status           = h.status;
    health.diskSpaceStatus  = h.diskSpace.status;
    health.diskSpaceTotal   = h.diskSpace.total;
    health.diskSpaceFree    = h.diskSpace.free;
    health.diskSpaceUsed    = health.diskSpaceTotal - health.diskSpaceFree;
    health.diskSpacePercent = health.diskSpaceUsed / health.diskSpaceTotal * 100;
    health.dbStatus         = h.db.status;
    health.dbName           = h.db.database;

    return health;
  }
}
